"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable max-len */
var _default = exports["default"] = 'M23.285 15.504l-2.245-2.236a.5.5 0 0 0-.705.709l1.385 1.38H9.986c-.51 0-.781-.344-.864-.666-.083-.32-.015-.749.429-.997l4.526-2.517a1.86 1.86 0 0 0 .91-2.12 1.868 1.868 0 0 0-1.833-1.415H2.28L3.667 6.26a.5.5 0 0 0-.705-.709L.716 7.787a.5.5 0 0 0 0 .71l2.246 2.236a.5.5 0 0 0 .704-.709L2.28 8.642h10.875c.51 0 .782.343.865.666.082.32.014.75-.428.996l-4.527 2.517a1.863 1.863 0 0 0-.912 2.121 1.87 1.87 0 0 0 1.833 1.415h11.736l-1.388 1.382a.5.5 0 0 0 .706.71l2.245-2.236a.498.498 0 0 0 0-.709';